module.exports = __webpack_public_path__ + "img/nolike.2db88a46.png";